import {NgModule} from "@angular/core";
import {FormsModule} from '@angular/forms';
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";

import {BsDropdownModule} from 'ngx-bootstrap';

import {BasicLayoutComponent} from "./basicLayout.component";
import {AdminLayoutComponent} from "./adminLayout.component";
import {BlankLayoutComponent} from "./blankLayout.component";
import {TopNavigationLayoutComponent} from "./topNavigationlayout.component";

import {NavigationComponent} from "./../navigation/navigation.component";
import {FooterComponent} from "./../footer/footer.component";
import {TopNavbarComponent} from "../navigation/topnavbar.component";
import {TopNavigationNavbarComponent} from "../navigation/topnavigationnavbar.component";


import {ProgressComponent} from "../progress/progress.component";
import {AlertService, ProgressService, AuthenticationService} from "../../../services";

@NgModule({
    declarations: [
        FooterComponent,
        BasicLayoutComponent,
        AdminLayoutComponent,
        BlankLayoutComponent,
        NavigationComponent,
        TopNavigationLayoutComponent,
        TopNavbarComponent,
        TopNavigationNavbarComponent,
        ProgressComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        BsDropdownModule.forRoot()
    ],
    exports: [
        FooterComponent,
        BasicLayoutComponent,
        BlankLayoutComponent,
        NavigationComponent,
        TopNavigationLayoutComponent,
        TopNavbarComponent,
        TopNavigationNavbarComponent,
        ProgressComponent
    ],
    providers: [
        AlertService,
        ProgressService,
        AuthenticationService
    ]
})

export class LayoutsModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/layouts/layouts.module.ts